import { render, staticRenderFns } from "./lxp-101.vue?vue&type=template&id=b7752d42"
var script = {}
import style0 from "./lxp-101.vue?vue&type=style&index=0&id=b7752d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports